import React, {createRef, useCallback} from "react";
export function useChildrenInteraction({
  condition,
  conditionAction,
  conditionActionElse
}) {
  const childrenMap = useCallback(({
    child: allChildren,
    arrayRefs
  }) => {
    return React.Children.map(allChildren, (child) => setElement({
      child,
      condition,
      conditionAction,
      conditionActionElse,
      arrayRefs
    }));
  }, [condition, conditionAction, conditionActionElse]);
  const setElement = useCallback(({
    child,
    condition: ownCondition = condition,
    conditionAction: ownConditionAction = conditionAction,
    conditionActionElse: ownConditionActionElse = conditionActionElse,
    arrayRefs = []
  }) => {
    if (Array.isArray(child)) {
      return childrenMap({
        child,
        arrayRefs
      });
    }
    let elementChild = child;
    if (/* @__PURE__ */ React.isValidElement(elementChild)) {
      if (!ownCondition || ownCondition(elementChild)) {
        elementChild = ownConditionAction(elementChild, arrayRefs);
      } else if (ownConditionActionElse) {
        elementChild = ownConditionActionElse(elementChild, arrayRefs);
      } else if (elementChild.props.children) {
        elementChild = /* @__PURE__ */ React.cloneElement(elementChild, {
          children: setElement({
            child: elementChild.props.children,
            arrayRefs
          })
        });
      }
    }
    return elementChild;
  }, [childrenMap, condition, conditionAction, conditionActionElse]);
  return useCallback((children) => {
    let refChildren;
    const arrayRefs = [];
    if (Array.isArray(children) ? children.length : !!children) {
      refChildren = childrenMap({
        child: children,
        condition,
        conditionAction,
        conditionActionElse,
        arrayRefs
      });
    }
    return [refChildren, arrayRefs];
  }, [childrenMap, condition, conditionAction, conditionActionElse]);
}
export function useParseChildren({
  condition,
  extraProps
}) {
  const conditionAction = useCallback((elementChild, arrayRefs = []) => {
    const childRef = elementChild.ref || /* @__PURE__ */ createRef();
    arrayRefs.push(childRef);
    const props = {
      ref: childRef,
      ...extraProps
    };
    return elementChild.ref ? elementChild : /* @__PURE__ */ React.cloneElement(elementChild, props);
  }, [extraProps]);
  return useChildrenInteraction({
    condition,
    conditionAction
  });
}
